<template>
	<div class="time-entry-done-skeleton">
		<SuiIcon name="icon-check-24" />
	</div>
</template>

<script setup lang="ts">
import { SuiIcon } from '@developers/scoro-ui';
</script>

<style lang="scss">
.time-entry-done-skeleton {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	height: 4rem;
	padding: 0.5rem;

	--sui-icon-fill: #{$neutral-40};
}
</style>
